import { useQuery } from '@tanstack/react-query'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery, useApi } from '@fortem-monorepo/react-spa'
import { MonthlyRoll } from '@fortem-monorepo/web-sdk'

import { getMonthlyRollOptions } from '@/react-query/queries/monthly-roll'

const colDefs = createColDefs([
  { field: 'CCY Pair' },
  { field: 'Dealt CCY' },
  { field: 'Type' },
  { field: 'Account' },
  { field: 'Date 1' },
  { field: 'Dir' },
  { field: 'Amount 1', valueFormatter: numberFormatter({ delimiter: true }) },
  { field: 'Amount 2', valueFormatter: numberFormatter({ delimiter: true }) },
])

export interface MonthlyRollDataTableProps {
  params: MonthlyRoll.GetMonthlyRollParams
}

export const MonthlyRollDataTable: React.FC<MonthlyRollDataTableProps> = ({ params }) => {
  const api = useApi()
  const query = useQuery({
    ...getMonthlyRollOptions(api, params),
    enabled: false,
  })

  return (
    <Widget exposed className={'h-full'}>
      <WidgetHeaderWithQuery query={query} title={'Report'} />
      <WidgetContent loading={query?.isLoading}>
        <CustomAgGrid
          columnDefs={colDefs}
          rowData={query.data?.report}
          domLayout={'normal'}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}
